<script>
import formInput from "@wielink-application/shared/js/mixins/formInput";

export default {
  mixins: [formInput],
  props: {
    'groupClasses': {
      type: String,
      required: false
    },
    'label': {
      type: String,
      required: false
    },
    'step': {
      type: String,
      required: false,
      default: '0.01'
    }
  }
}
</script>

<template>
  <div class="input-group">
    <span class="input-group-text" :id="`${renderedId}-addon`">
      &euro;
    </span>
    <input
        :name="name"
        v-bind="$attrs"
        @input="changeModelValue"
        type="number"
        :step="step"
        :id="renderedId"
        :class="{'form-control': true, 'border-danger': hasError}"
        :value="modelValue"
        :aria-describedby="`${renderedId}-addon`"
    >
  </div>

  <label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>